import {ClothesList} from "../../modules/Clothes";

export default function ClothesScreen() {
    return (
        <>
            <ClothesList/>
        </>
    )
}    